import React, { useMemo } from 'react';
import { Label } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { container } from './styles';

type TProps = {
  amountBox: number;
  areaPerBox: number;
};

export const PdpProjectBoxCount: React.FC<TProps> = ({ amountBox, areaPerBox }) => {
  const { t } = useTranslation();
  const approximateAreaForAllBoxes = useMemo(() => {
    return Math.floor(amountBox * areaPerBox * 1000) / 1000;
  }, [amountBox, areaPerBox]);
  const boxCountText = `${amountBox} ${t('product-card.measurement-inits.boxes')}`;
  const areaText = `${approximateAreaForAllBoxes} ${t('product-card.measurement-inits.m2')}`;
  const labelText = `${boxCountText} = ${areaText}`;

  return (
    <div data-qa="pdp-project-box-count" className={container}>
      <Label background="background-primary" borderColor="control-minor" color="text-secondary">
        {labelText}
      </Label>
    </div>
  );
};
